import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 mb-4">
            Najpopularniejsze <span className="text-primary-500">kategorie</span>
          </h2>
          <p className="text-base text-foreground-500 max-w-xl mx-auto">
            Przeglądaj wszystkie kategorie produktów w arkuszu Kakobuy Spreadsheet. Każda kategoria zawiera starannie wyselekcjonowane znaleziska.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <a
              key={idx}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative aspect-[3/4] rounded-lg overflow-hidden cursor-pointer bg-background-100"
            >
              <img
                src={cat.imageUrl}
                alt={`${cat.name} - Kakobuy Spreadsheet kategoria`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white text-base md:text-lg font-semibold font-heading">{cat.name}</h3>
                <span className="text-white/70 text-xs mt-1 inline-block opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Przejdź do kategorii →
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}